'use strict';

let inputs = document.getElementsByClassName('js-validate-number');

Array.from(inputs).forEach((element) => {
    element.tempValue = 1;
    element.addEventListener('input', () => {
        element.validity.valid ? element.tempValue = element.value : element.value = element.tempValue;
    });
});



// WEBPACK FOOTER //
// ./src/js/components/validate-number.js